<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 32"
    class="icon-svg icon-amex"
  >
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <g
        transform="translate(-1288 -906) translate(1176 140) translate(0 614) translate(0 152) translate(112)"
      >
        <rect
          width="47"
          height="31"
          x=".5"
          y=".5"
          stroke="#d5d5d5"
          fill="#FFFFFF"
          rx="4"
        />
        <g fill-rule="nonzero">
          <path
            fill="#7673C0"
            d="M10 1L18 1 18 14 10 14z"
            transform="translate(10 8)"
          />
          <path
            fill="#EB001B"
            d="M10.695 8.001c-.006-2.45 1.212-4.768 3.305-6.29-3.542-2.58-8.656-2.202-11.704.862-3.061 3.065-3.061 7.79 0 10.854 3.048 3.064 8.161 3.441 11.703.863-2.092-1.522-3.31-3.84-3.305-6.289z"
            transform="translate(10 8)"
          />
          <path
            fill="#00A1DF"
            d="M27.055 13.78v-.907h.193v-.194h-.487v.194h.192v.94l.102-.033zm.945 0v-1.134h-.147l-.172.81-.171-.81h-.152v1.134h.106v-.85l.16.738h.11l.16-.738v.86l.106-.008v-.002zm-.26-5.778c0 3.062-1.857 5.855-4.78 7.193-2.924 1.339-6.41.987-8.96-.904 2.053-1.524 3.248-3.84 3.246-6.29 0-2.455-1.197-4.773-3.246-6.29 2.55-1.893 6.037-2.245 8.96-.907C25.887 2.143 27.743 4.937 27.743 8l-.002.002z"
            transform="translate(10 8)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
